import Typography from "components/Typography";
import { error } from "configs/colors";
import TLNStack from "pages/Components/Stack";
import { rem } from "utils";

interface HeadingProps {
  title: string;
  subTitle: string;
  required?: boolean;
  textProps?: Partial<React.ComponentProps<typeof Typography>>;
}

const Heading: React.FC<HeadingProps> = ({
  title,
  subTitle,
  required,
  textProps,
}) => {
  return (
    <TLNStack.Normal>
      <Typography
        sx={{
          "&::after": {
            content: required ? '"*"' : '""',
            color: error[600],
            marginLeft: rem(4),
          },
        }}
        fontWeight={600}
        type="TextMD"
        color="grey.700"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...textProps}
      >
        {title}
      </Typography>
      <Typography fontWeight={300} type="TextSM" color="grey.600">
        {subTitle}
      </Typography>
    </TLNStack.Normal>
  );
};

export default Heading;
